export { CurrencyPound as default } from './CurrencyPound';
